import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

/** Auth & guide pages — clean layout matching landing aesthetic */
const PublicLayout = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
      bgcolor: 'background.default',
    }}
  >
    <Outlet />
  </Box>
);

export default PublicLayout;
